import React, { useEffect, useState } from "react";
import BulkUploadDriverPropertiesModal from "../../components/BulkUploadDriverProperties";

const BulkUploadDriverProperties = (props) => {
  return <BulkUploadDriverPropertiesModal />;
};

export default BulkUploadDriverProperties;
